<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" clearable :placeholder="$t('menu.fhddh')"
          v-model="formInline.poShipmentId"></el-input>
       
      </el-form-item>
      
     
     
    
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
           <el-button type="primary" @click="dkl()">{{ $t('menu.peijianfh') }}</el-button>
            <el-button type="primary" @click="zcf()">{{ $t('menu.zhgengchefahg') }}</el-button>
      
      </el-form-item>
    </el-form>
   
    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
      <el-table-column prop="shippedTime"  :label="$t('menu.fhdfhsj')" >
          <template slot-scope="scope"> 
            {{ scope.row.shippedTime?scope.row.shippedTime.slice(0,10):'' }}
          </template>
      </el-table-column>
      <el-table-column prop="logisticsNumber"  :label="$t('menu.fhddh')" >
        
      </el-table-column>
      <el-table-column prop="logisticsNumber"  :label="$t('menu.cgwdlx')" > 
          <template slot-scope="scope"> 
          <div v-if="scope.row.orderType==2">
            {{ $t('menu.Vehicle') }}
          </div>
          <div v-else>
            {{ $t('menu.Parts') }}
          </div>
          </template>
      </el-table-column>
      <el-table-column prop="poNums"  :label="$t('menu.fhdglpj')" > </el-table-column>
     <el-table-column prop="dealerName"  :label="$t('menu.zcmxlsh')" > </el-table-column>
     <!-- <el-table-column prop="address"  :label="$t('menu.Countrya')" > 
       <template slot-scope="scope"> 
          <div>
            {{queaera(scope.row.address)  }}
          </div>
         
          </template> 
      
     </el-table-column> -->
      <el-table-column prop="shippedQuantity"  :label="$t('menu.fhdfhsl')"> </el-table-column>
      
      <!-- <el-table-column prop="partName"  label="发货整车数量" > </el-table-column> -->
   
      <el-table-column prop="address"  :label="$t('menu.Operation')" > 
       <template slot-scope="scope"> 
        
          <el-button type="text" @click="mx(scope.row.id)"> {{ $t('menu.wbdymx') }}</el-button>
          </template> 
      
     </el-table-column>
     
     
     
    </el-table>
 <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total,sizes, prev, pager, next"
        :total="totale">
      </el-pagination>
    </div>
     <el-dialog :title="$t('menu.zhgengchefahg')" :visible.sync="dialogVisiblevin" v-if="dialogVisiblevin" width="800px" @close="ccac" :close-on-click-modal="false">
      <div class="partBox">
        <div class="searchBox" >
         <!-- <div style="display: flex; width: 300px;align-items: center;">
          <div style="width: 80px;">{{ $t('menu.kehugongsi') }}：</div>
           <el-select style="width: 200px;" v-model="dealerid" placeholder="请选择">
              <el-option
                v-for="item in cartypelist"
                :key="item.id"
                :label="item.dealerName"
                :value="item.id">
              </el-option>
            </el-select>
         </div> -->
          <!-- <div style="display: flex; width: 300px;margin-top: 20px;align-items: center;">
          <div style="width: 80px;">{{$t('menu.ShipmentNo')}}：</div>
           <el-input style="width: 200px;" v-model="logisticsNumber" :placeholder=" $t('menu.Enter') "></el-input>
         </div> -->
          <div style="display: flex; width: 300px;margin: 20px 0;align-items: center;">
           <el-upload action="#" :multiple="false"   list-type="icon" :on-preview="handlePictureCardPreview" :http-request="uploadFile" :before-upload="beforeAvatarUpload" 
          :file-list="fileList" :show-file-list="false">
          <el-button size="small" type="text">{{$t('menu.changchuanvin')}}</el-button>
          

        </el-upload>
           <!-- <el-button  type="primary"  @click="pjlis">上传车架号</el-button> -->
             <el-button type="text" @click="xzmb()" style="margin-left: 20px;">{{$t('menu.xiazaimuban')}}</el-button>
           
         </div>
        </div>
        
        <el-table  empty-text=" " :data="partList" border style="width: 100%"  height="500">
    
          <el-table-column prop="orderNumber" :label="$t('menu.xiaoshoudh')" min-width="80"></el-table-column>
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')" min-width="80"></el-table-column>
          <el-table-column  :label="$t('menu.PartName')" min-width="80">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partName : scope.row.partNameEn }}
            </template>
          </el-table-column>
          <el-table-column prop="vin" :label="$t('menu.chejiahao')" min-width="80"></el-table-column>
          <!-- <el-table-column prop="quantity" :label="$t('menu.daifashul')" min-width="80"></el-table-column> -->
           
          
       
            <!-- <el-table-column  :label="$t('menu.bencufahuo')" min-width="180">
            <template slot-scope="scope">
              <el-input-number style="width: 100%;"  v-model="scope.row.shippedQuantity" @change="tongji" :min="1"  label="描述文字"></el-input-number>
              <div style="color: red; font-size: 10px;" v-if="scope.row.shippedQuantity>scope.row.quantity">最大数量不得超过待发数量</div>
            </template>
          </el-table-column> -->
            <el-table-column  :label="$t('menu.Operation')" min-width="80">
            <template slot-scope="scope">
               <el-button type="text" @click="dele(scope)">{{$t('menu.Delete')}}</el-button>
             </template>
          </el-table-column>
           
        </el-table>
        <div style="margin: 10px 0;">
          {{$t('menu.fahuozongshu')}}：{{ numtj }}
        </div>
        <div class="buttBox">
          <el-button type="primary" :disabled="partList.length<=0"  @click="getpartLista">{{$t('menu.Confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>

  <el-dialog :title="$t('menu.fahuod')" :visible.sync="dialogVisiblePart" v-if="dialogVisiblePart" width="800px" @close="ccac" :close-on-click-modal="false">
      <div class="partBox">
        <div class="searchBox" >
         <div style="display: flex; width: 300px;align-items: center;">
          <div style="width: 80px;">{{ $t('menu.kehugongsi') }}：</div>
           <el-select style="width: 200px;" v-model="dealerid" placeholder="请选择">
              <el-option
                v-for="item in cartypelist"
                :key="item.id"
                :label="item.dealerName"
                :value="item.id">
              </el-option>
            </el-select>
         </div>
          <div style="display: flex; width: 300px;margin-top: 20px;align-items: center;">
          <div style="width: 80px;">{{$t('menu.ShipmentNo')}}：</div>
           <el-input style="width: 200px;" v-model="logisticsNumber" :placeholder=" $t('menu.Enter') "></el-input>
         </div>
          <div style="display: flex; width: 300px;margin: 20px 0;align-items: center;">
         
           <el-button  type="primary"  @click="pjlis">{{$t('menu.AddTo')}}</el-button>
             <!-- <el-button type="text"  style="margin-left: 20px;">{{$t('menu.xiazaimuban')}}</el-button> -->
           
         </div>
        </div>
        
        <el-table  empty-text=" " :data="partList" border style="width: 100%"  height="500">
    
          <el-table-column prop="orderNumber" :label="$t('menu.xiaoshoudh')" min-width="80"></el-table-column>
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')" min-width="80"></el-table-column>
          <el-table-column  :label="$t('menu.PartName')" min-width="80">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partName : scope.row.partNameEn }}
            </template>
          </el-table-column>
          
          <el-table-column prop="quantity" :label="$t('menu.Quantity')" min-width="80"></el-table-column>
           
          
       
            <el-table-column  :label="$t('menu.bencufahuo')" min-width="180">
            <template slot-scope="scope">
              <el-input-number style="width: 100%;" v-model="scope.row.shippedQuantity" @change="tongji" :min="1"  label="描述文字"></el-input-number>
              <!-- <el-input v-model.number="scope.row.shippedQuantity" oninput="value=value.replace(/[^\d]/g,'')" @input="tongji()"> </el-input> -->
              <div style="color: red; font-size: 10px;" v-if="scope.row.shippedQuantity>scope.row.quantity">最大数量不得超过待发数量</div>
            </template>
          </el-table-column>
            <el-table-column  :label="$t('menu.Operation')" min-width="80">
            <template slot-scope="scope">
               <el-button type="text" @click="dele(scope)">{{$t('menu.Delete')}}</el-button>
             </template>
          </el-table-column>
           
        </el-table>
        <div style="margin: 10px 0;">
        {{$t('menu.fahuozongshu')}}：{{ numtj }}
        </div>
        <div class="buttBox">
          <el-button type="primary" :disabled="partList.length<=0"  @click="getpartList">{{$t('menu.Confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>
      <el-dialog :title="$t('menu.fahuod')" :visible.sync="dialogVisible" v-if="dialogVisible" width="800px" @close="ccac" :close-on-click-modal="false">
      <div class="partBox">
        <div class="searchBox" >
         
          <div style="display: flex; width: 300px;margin-bottom: 20px;align-items: center;">
           <el-input style="width: 200px;margin-right: 10px;" v-model="skvue" placeholder="配件名称/销售单号"></el-input>
            
             <el-button  type="primary"  @click="polissub">{{$t('menu.sousuo')}}</el-button>
         </div>
          
        </div>
        
        
           <el-table  empty-text=" " :data="polist" border style="width: 100%" @selection-change="handleSelectionChange"  height="500">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="orderNumber" :label="$t('menu.xiaoshoudh')" min-width="80"></el-table-column>
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')" min-width="80"></el-table-column>
          <el-table-column  :label="$t('menu.PartName')" min-width="80">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partName : scope.row.partNameEn }}
            </template>
          </el-table-column>
          
          <el-table-column prop="quantity" :label="$t('menu.Quantity')" min-width="80"></el-table-column>
        </el-table>
        <div class="buttBox" style="margin-top: 10px;">
          <el-button type="primary" @click="getppo()">{{$t('menu.AddTo')}}</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="$t('menu.wbdymx')" :visible.sync="dialogVisibleac" v-if="dialogVisibleac" width="800px" @close="ccac" :close-on-click-modal="false">
      <div class="partBox" >
           <el-table  empty-text=" " :data="polista" border style="width: 100%"   height="500">
        
          <el-table-column prop="poNum" :label="$t('menu.fhdglpj')"  min-width="80"></el-table-column>
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')"  min-width="80"></el-table-column>
          <el-table-column  :label="$t('menu.PartName')" min-width="80">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partName : scope.row.partNameEn }}
            </template>
          </el-table-column>
           <el-table-column prop="vin" :label="$t('menu.chejiahao')" min-width="80"></el-table-column>
          <el-table-column prop="shippedQuantity" :label="$t('menu.Quantity')" min-width="80"></el-table-column>
        </el-table>
     
      </div>
      <!-- <div class="partBox" v-if="orty=='1'">
           <el-table :data="polista" border style="width: 100%"   height="500">
        
          
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')"  min-width="80"></el-table-column>
          <el-table-column  :label="$t('menu.PartName')" min-width="80">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partName : scope.row.partNameEn }}
            </template>
          </el-table-column>
          
          <el-table-column prop="quantity" :label="$t('menu.Quantity')" min-width="80"></el-table-column>
        </el-table>
     
      </div>
      <div class="partBox" v-else>
           <el-table :data="polista" border style="width: 100%"   height="500">
        
          
          <el-table-column prop="motorColor" :label="$t('menu.VehicleModel')" min-width="80"></el-table-column>
            <el-table-column prop="motorName" :label="$t('menu.chekuan')" min-width="80"></el-table-column>
            
          
          
          <el-table-column prop="vin" :label="$t('menu.FrameNumber')" min-width="80"></el-table-column>
        </el-table>
     
      </div> -->
    </el-dialog>
  </div>
</template>
  
  <script>

import { xjshipmentOfDealer,retailerlist,gbquerytype,pageQueryPoPart,uploadaacx,subshipmentOfDealer,pmportVin,shipdele,pageQueryPoPartByImportVin } from "../../api/api";

export default {
  data () {
    return {
      userId: null,
      dialogVisiblePart:false,
      dialogVisible:false,
      mation: [], //列表
      cartypelist: [],
      formInline: {
        poShipmentId: "",
       
      },
      pageSize:10,
      currentPage3:1,
      aeera:[],
      iszh:sessionStorage.getItem('i18n'),
      dealerid:'',
      logisticsNumber:'',
      skvue:'',
      polist:[],
      pslslist:[],
      partList:[],
      numtj:0,
      dialogVisibleac:false,
      polista:[],
      fileList:[],
      orty:'1',
      dialogVisiblevin:false,
    };
  },
  created () {
    // this.listMcSeriesModel()
    this.getList()
    this.getQuerytype()
    this.aeer()
  },
 
  methods: {
    zcf(){
      this.dialogVisiblevin=true
    },
   
     beforeAvatarUpload(file){
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isLt2M;
    },
     handlePictureCardPreview (file) {
   
    },
    uploadFile (file) {
      let formdata = new FormData()
      formdata.append('file', file.file)
      formdata.append('category', file.file.type)
      uploadaacx(formdata).then(res => {
        if (res.data.code == '200') {
          this.$message.success('上传成功')
          let obj = {
            name:res.data.newFileName,
            url:res.data.url
          }
         
          console.log(obj);
         let param = new URLSearchParams(); 
         let a = obj.url
            pmportVin(param,a).then(re1 => {
              console.log(123123,re1.data.data);
              
              this.partList=re1.data.data
              let bnum=0
              re1.data.data.forEach((zzz,iii)=>{
                 this.partList[iii].shippedQuantity=zzz.importShippedQuantity
                bnum=bnum+zzz.importShippedQuantity
              })
              this.numtj=bnum
            })

          
        } else {
          this.$message.error('上传失败')
        }
      })
    },
   async xzmb(){
    let param = new URLSearchParams(); 
      pageQueryPoPartByImportVin(param).then(res => {
        
        const url = window.URL.createObjectURL(new Blob([res.data]));
        // 创建一个<a>元素，用于模拟点击下载文件
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件的名称
        link.setAttribute('download', '发货单模板.xlsx');
        // 将<a>元素添加到文档中
        document.body.appendChild(link);
        // 模拟点击下载
        link.click();
        // 移除<a>元素
        // link.remove();
        // 释放创建的URL对象，避免内存泄漏
        window.URL.revokeObjectURL(url);
      })

    },
    async aeer () {
      let param = new URLSearchParams(); 
      const { data: res } =  await gbquerytype(param, 'sys_dealer_area/%20/', sessionStorage.getItem('userId'));
      this.aeera = res.data
    },
    queaera(e){
      let a =''
      this.aeera.forEach(z=>{
        if(z.dictValue==e){
          a=z.dictLabel
        }
      })
      return a
    },
   async mx(e){
      this.dialogVisibleac=true
      
      let param = new URLSearchParams(); 
      const { data: res } =  await shipdele(param, e);
      let a =res.data
      this.orty=a.orderType
     
        this.polista=a.detailParts
      
    
      
    },
    dele(e){
      console.log(e.$index);
       this.partList.splice(e.$index,1)
       this.tongji()
    },
    ccac(){
      this.dialogVisiblePart=false
      this.dialogVisible=false
      this.dialogVisiblevin=false
      this.dialogVisibleac=false
      this.getList()
       this.dealerid=''
      this.logisticsNumber=''
      this.pslslist=[]
      this.skvue=''
      this.numtj=0
      this.partList=[]
      this.pslslist=[]

    },
    getppo(){
       this.dialogVisible=false
       let a =[]
       this.partList.forEach(e=>{
        a.push(e.poPartId)
       })
       this.pslslist.forEach(e=>{
        if(a.indexOf(e.poPartId)==-1){
          this.partList.push(e)
        }
       })
      //  this.partList=this.pslslist
       this.tongji()
       
    },
    tongji(){
      console.log(1);
      
      let a =this.partList
      let num = 0 
      a.forEach(e=>{
        num=num+Number(e.shippedQuantity)
      })
      this.numtj =num
    },
    dkl(){
       this.dialogVisiblePart=true
    },
     pjlis(){
       if(this.dealerid==''){
         this.$message.error('请先选择零售商')
         return false
       }
       this.dialogVisible=true
      this.pslslist=[]
      this.skvue=''
        this.polissub()
       
    },
    getpartList(){
       
        // let params = new URLSearchParams();
        let ac=this.pslslist
        let b = []
         ac.forEach(e=>{
          let c =e
          
 
        c.id=null
        b.push(c)
       
       })
        
          let data={
            dealerId:this.dealerid,
            logisticsNumber:this.logisticsNumber,
            orderType:1,
            detailParts: b
          }
       subshipmentOfDealer(data).then(res => {
      
        
        if (res.data.code == 200) {
          this.ccac()
           this.$message.success('发货成功')
          // this.polist = res.data.data.list
       
        }else{
            this.$message.error(res.data.msg)
        }
      })
    },
    getpartLista(){
       
        // let params = new URLSearchParams();
        let ac=this.partList
        let b = []
         ac.forEach(e=>{
          let c =e
          c.poNum=c.orderNumber
          c.poPartId=c.id
          c.shippedQuantity=c.importShippedQuantity
          c.quantity= c.quantity-c.shippedQuantity 
           c.poShipmentId = null
          c.remarks = null
          c.deleted = 0
          c.createdById = null
          c.createdTime = null
          c.updatedById = null
          c.updatedTime = null
        c.id=null
        b.push(c)
       
       })
        
          let data={
           
            detailParts: b
          }
       subshipmentOfDealer(data).then(res => {
      
        
        if (res.data.code == 200) {
          this.ccac()
           this.$message.success('发货成功')
          // this.polist = res.data.data.list
       
        }else{
            this.$message.error(res.data.msg)
        }
      })
    },
    polissub(){
        let params = new URLSearchParams();
      //  &statusList['+0+']=2&statusList[1]=3
      
    
       pageQueryPoPart(params,1,100,this.dealerid,this.skvue).then(res => {
      
        
        if (res.data.code == 200) {
          this.polist = res.data.data.list
       
        }
      })
    },
     handleSelectionChange(val) {
      console.log(val);
       val.forEach(e=>{
        e.shippedQuantity=e.quantity
        e.deleted=0
        e.poShipmentId=''
       e.poPartId=e.id
       })
        this.pslslist = val;
      },
    
      handleSizeChange (val) {
      this.pageSize = val
      this.getList();
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.getList();
    },
   
    //查询车辆列表
    getList () {
 
      let params = new URLSearchParams();
     
    let logisticsNumber=this.formInline.poShipmentId
      let curPage=this.currentPage3
      let pageSize=this.pageSize
      xjshipmentOfDealer(params,curPage,pageSize,logisticsNumber).then(res => {
        if (res.data.code == 200) {
          this.mation = res.data.rows
          this.totale = res.data.total
        }
      })
    },
   
   
   
 
    //搜索
    onSubmit () {
      this.getList()
    },
  
     //零售商
    getQuerytype () {
 
      const params = new URLSearchParams()
      retailerlist( params, 1,1000).then(r => {
        console.log(r);
        this.cartypelist = r.data.rows;
    
      })
    },
    
  
  },
};
</script>

<style lang="less" scoped>
.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

</style>